import { AlertTriangle, CheckCircle2, Info, X } from 'lucide-react';
import { useT } from '../i18n';
import { Portal } from './Portal';
import { IconButton } from './IconButton';
import { useToastStore } from './ToastStore';
import s from './Toast.module.css';

const icons = {
  success: <CheckCircle2 size={20} />,
  error: <AlertTriangle size={20} />,
  info: <Info size={20} />,
};

/** Zone d'affichage des notifications ; à monter une seule fois dans l'application. */
export function ToastViewport() {
  const { t } = useT();
  const toasts = useToastStore((x) => x.toasts);
  const dismiss = useToastStore((x) => x.dismiss);
  return (
    <Portal>
      <div className={s.viewport} role="region" aria-label={t('ui.notifications')}>
        {toasts.map((item) => (
          <div key={item.id} className={`${s.toast} ${s[item.tone]}`} role={item.tone === 'error' ? 'alert' : 'status'}>
            <span className={s.icon}>{icons[item.tone]}</span>
            <div className={s.text}>
              <strong>{item.title}</strong>
              {item.description && <p>{item.description}</p>}
            </div>
            <IconButton label={t('ui.close')} icon={<X size={16} />} size="sm" onClick={() => dismiss(item.id)} />
          </div>
        ))}
      </div>
    </Portal>
  );
}
